import Alpine from "alpinejs";
import Clipboard from '@ryangjchandler/alpine-clipboard';

import "./js/theme";
import "./js/alpine-store";
import "./js/alpine-money";

window.waitForElement = function(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

window.Alpine = Alpine;

window.countryProvinceData = [];

// window.countryProvinceData = require("country-province-data").map((country) => {
//     if (country.name == "United Kingdom") {
//         country.provinces = [
//             "Bedfordshire",
//             "Buckinghamshire",
//             "Cambridgeshire",
//             "Cheshire",
//             "Cleveland",
//             "Cornwall",
//             "Cumbria",
//             "Derbyshire",
//             "Devon",
//             "Dorset",
//             "Durham",
//             "East Sussex",
//             "Essex",
//             "Gloucestershire",
//             "Greater London",
//             "Greater Manchester",
//             "Hampshire",
//             "Hertfordshire",
//             "Kent",
//             "Lancashire",
//             "Leicestershire",
//             "Lincolnshire",
//             "Merseyside",
//             "Norfolk",
//             "North Yorkshire",
//             "Northamptonshire",
//             "Northumberland",
//             "Nottinghamshire",
//             "Oxfordshire",
//             "Shropshire",
//             "Somerset",
//             "South Yorkshire",
//             "Staffordshire",
//             "Suffolk",
//             "Surrey",
//             "Tyne and Wear",
//             "Warwickshire",
//             "West Berkshire",
//             "West Midlands",
//             "West Sussex",
//             "West Yorkshire",
//             "Wiltshire",
//             "Worcestershire",
//             "Flintshire",
//             "Glamorgan",
//             "Merionethshire",
//             "Monmouthshire",
//             "Montgomeryshire",
//             "Pembrokeshire",
//             "Radnorshire",
//             "Anglesey",
//             "Breconshire",
//             "Caernarvonshire",
//             "Cardiganshire",
//             "Carmarthenshire",
//             "Denbighshire",
//             "Aberdeen City",
//             "Aberdeenshire",
//             "Angus",
//             "Argyll and Bute",
//             "City of Edinburgh",
//             "Clackmannanshire",
//             "Dumfries and Galloway",
//             "Dundee City",
//             "East Ayrshire",
//             "East Dunbartonshire",
//             "East Lothian",
//             "East Renfrewshire",
//             "Eilean Siar",
//             "Falkirk",
//             "Fife",
//             "Glasgow City",
//             "Highland",
//             "Inverclyde",
//             "Midlothian",
//             "Moray",
//             "North Ayrshire",
//             "North Lanarkshire",
//             "Orkney Islands",
//             "Perth and Kinross",
//             "Renfrewshire",
//             "Scottish Borders",
//             "Shetland Islands",
//             "South Ayrshire",
//             "South Lanarkshire",
//             "Stirling",
//             "West Dunbartonshire",
//             "West Lothian",
//             "Antrim",
//             "Armagh",
//             "Down",
//             "Fermanagh",
//             "Derry and Londonderry",
//             "Tyrone"
//         ].sort();
//     }

//     return {
//         name: country.name,
//         provinces: country.provinces,
//     }
// })

Alpine.plugin(Clipboard);
Alpine.start();
